import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Label } from './TextField';
import styles from './Inputs.module.css';
import DisplayErrorMessages from './DisplayErrorMessages';
import { ReactComponent as InfoSVG } from '../../../../Assets/icons/info.svg';

function Radios(props) {
  const {
    formData,
    inputName,
    error,
    label,
    options,
    required = false,
    onChange = () => {},
    viewMode = false,
    errorText = null,
    disabled = false,
  } = props;
  if (!viewMode) {
    return (
      <FormControl variant="standard" component="fieldset" required={required}>
        <Label label={label} required={required} error={error} />
        <RadioGroup
          required={required}
          aria-label={label}
          value={formData[inputName]}
          onChange={(e) => {
            onChange(inputName, e.target.value);
          }}
        >
          {options.map((radio) => (
            <div key={radio.value}>
              <FormControlLabel
                style={{ margin: '5px' }}
                value={radio.value}
                control={<Radio color="primary" />}
                label={radio.label}
                disabled={disabled}
                className={styles.formControlLabel}
              />
              {radio.tooltip ? (
                <Tooltip
                  placement="top"
                  title={radio.tooltip}
                  classes={{ tooltip: styles.radioTooltip }}
                >
                  <InfoSVG className={styles.radioTooltipIcon} />
                </Tooltip>
              ) : null}
            </div>
          ))}
        </RadioGroup>
        <DisplayErrorMessages error={error} errorText={errorText} />
      </FormControl>
    );
  }
  return (
    <div className={styles.twoColumnLayout}>
      <div className={styles.labelColumn}>{label}</div>
      <div className={styles.valueColumn}>
        <span className={styles.tag}>
          {options.find((opt) => opt.value === formData[inputName])
            ? options.find((opt) => opt.value === formData[inputName]).label
            : '—'}
        </span>
      </div>
    </div>
  );
}

Radios.propTypes = {
  formData: PropTypes.shape({}).isRequired,
  inputName: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  errorText: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  viewMode: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Radios;
